import axios from "@/api/config_php";

// 获取Facebook授权链接接口
export const getFacebookAuthUrl = param => axios.get(`/amp/api/v1/facebook/getAuth`, { params: param });

export const syncFbstatus = param => axios.get(`/amp/api/v1/facebook/syncFbstatus`, { params: param });

// facebook广告数据增量同步接口文档
export const syncAllData = param => axios.get(`/amp/api/v1/facebook/syncAllData`, { params: param });

// Facebook回调处理接口
export const facebookAuthCallback = param => axios.post(`/amp/api/v1/facebook/callback`, param);

// Facebook广告账户
export const getFacebookAdAccounts = param => axios.get(`/amp/api/v1/facebook/adAccounts`, { params: param });
// Facebook广告系列列表
export const getFacebookAdCampaigns = param => axios.get(`/amp/api/v1/facebook/campaigns`, { params: param });
// Facebook广告组
export const getFacebookAdSets = param => axios.get(`/amp/api/v1/facebook/adSets`, { params: param });
// Facebook广告数据接口
export const getFacebookAds = param => axios.get(`/amp/api/v1/facebook/ads`, { params: param });

// 广告数据变更 保存已选广告
export const fbAdsSubmit = param => axios.post(`/amp/api/v1/facebook/adSave`, param);

// 广告数据变更中 已选并保存的 广告列表
export const getSavedSelectedAds = param => axios.get(`/amp/api/v1/facebook/adLists`, { params: param });

// 广告数据变更 已选并保存的 批量删除
export const deleteSavedSelectedAds = param => axios.post(`/amp/api/v1/facebook/adBatchDelete`, param);

// 广告数据变更中 已选并保存的 广告列表查询条件 - 账户
export const getSavedSelectedAdsParamsAccount = param => axios.get(`/amp/api/v1/facebook/fbAdChangeAccounts`, { params: param });

// 广告数据变更中 已选并保存的 广告列表查询条件 - 系列
export const getSavedSelectedAdsParamsCompaign = param => axios.get(`/amp/api/v1/facebook/fbAdChangeCampaigns`, { params: param });

// 广告数据变更中 已选并保存的 广告列表查询条件 - 组
export const getSavedSelectedAdsParamsSet = param => axios.get(`/amp/api/v1/facebook/fbAdChangeAdSets`, { params: param });

// 广告数据变更中 已选并保存的 广告列表查询条件 - 广告
export const getSavedSelectedAdsParamsAd = param => axios.get(`/amp/api/v1/facebook/fbAdChangeAds`, { params: param });

// 广告数据变更 更新文案缓存
export const saveFbAdCopywriting = param => axios.post(`/amp/api/v1/facebook/saveFbAdCopywriting`, param);

// 广告数据变更 获取文案缓存
export const getFbAdCopywritingDetail = param => axios.get(`/amp/api/v1/facebook/fbAdCopywritingDetail`, { params: param });

// 广告数据变更 更新文案缓存
export const submitAdUpdate = param => axios.post(`/amp/api/v1/facebook/submitAdUpdate`, param);
